import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Image as ImageIcon, Calendar, Newspaper, ShoppingBag, Camera, Mail, Users, Trophy } from "lucide-react";

const TILES = [
  { key: "banners", label: "Banners", icon: ImageIcon, color: "bg-[var(--pz-red)]/10 text-[var(--pz-red)]", to: "/admin/banners" },
  { key: "events", label: "Events", icon: Calendar, color: "bg-sky-500/10 text-sky-400", to: "/admin/events" },
  { key: "match_results", label: "Match Results", icon: Trophy, color: "bg-amber-500/10 text-amber-400", to: "/admin/match-results" },
  { key: "blogs", label: "Blog Posts", icon: Newspaper, color: "bg-emerald-500/10 text-emerald-400", to: "/admin/blogs" },
  { key: "products", label: "Products", icon: ShoppingBag, color: "bg-pink-500/10 text-pink-400", to: "/admin/products" },
  { key: "gallery", label: "Gallery", icon: Camera, color: "bg-violet-500/10 text-violet-400", to: "/admin/gallery" },
  { key: "inquiries", label: "Inquiries", icon: Mail, color: "bg-yellow-500/10 text-yellow-400", to: "/admin/inquiries" },
  { key: "subscribers", label: "Subscribers", icon: Users, color: "bg-rose-500/10 text-rose-400", to: "/admin/subscribers" },
];

export default function Dashboard() {
  const [stats, setStats] = useState({});
  useEffect(() => { api.get("/admin/dashboard").then(({ data }) => setStats(data)); }, []);

  return (
    <div data-testid="admin-dashboard" className="text-white">
      <h1 className="font-display text-4xl font-bold uppercase tracking-tight">Dashboard</h1>
      <p className="text-zinc-400 mt-1 text-sm">Quick overview of your arena.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {TILES.map((t) => {
          const Icon = t.icon;
          return (
            <Link to={t.to} key={t.key} data-testid={`stat-${t.key}`} className="admin-panel rounded-md p-5 hover:-translate-y-1 hover:border-[var(--pz-red)]/50 transition-all">
              <div className={`h-10 w-10 rounded-md grid place-items-center ${t.color}`}><Icon className="h-5 w-5" /></div>
              <div className="mt-4 text-3xl font-display font-bold">{stats[t.key] ?? 0}</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 font-bold mt-1">{t.label}</div>
            </Link>
          );
        })}
      </div>

      <div className="mt-12 admin-panel rounded-md p-6">
        <div className="font-display text-xl font-bold uppercase">Quick actions</div>
        <p className="text-zinc-400 text-sm mt-1">Most-used tasks, one tap away.</p>
        <div className="flex flex-wrap gap-2 mt-5">
          <Link to="/admin/banners" className="btn-outline">Update Banner</Link>
          <Link to="/admin/match-results" className="btn-outline">Add Match Result</Link>
          <Link to="/admin/events" className="btn-outline">Add Event</Link>
          <Link to="/admin/blogs" className="btn-outline">Publish a Post</Link>
          <Link to="/admin/notifications" className="btn-outline">Edit Notification</Link>
          <Link to="/admin/stats" className="btn-outline">Edit Stats</Link>
          <Link to="/admin/messages" className="btn-outline">Send Broadcast</Link>
          <Link to="/admin/settings" className="btn-outline">Settings</Link>
        </div>
      </div>
    </div>
  );
}
